// extracted by mini-css-extract-plugin
export default {"email":"EmailVerificationInfo_email__QmoY3","actions":"EmailVerificationInfo_actions__3xduX","changeEmail":"EmailVerificationInfo_changeEmail__cm0pL buttonSecondary"};